/**
 * Normalizes stored userPart.availableTime for display by locale.
 * Stored shape from SendReport: "{date}{' เวลา '|' at '}{HH:mm} - {HH:mm}"
 * Legacy Thai used month:'short' which often still shows English month names (Apr).
 */

const TH_MONTHS = [
  'มกราคม',
  'กุมภาพันธ์',
  'มีนาคม',
  'เมษายน',
  'พฤษภาคม',
  'มิถุนายน',
  'กรกฎาคม',
  'สิงหาคม',
  'กันยายน',
  'ตุลาคม',
  'พฤศจิกายน',
  'ธันวาคม',
]

const EN_SHORT = {
  jan: 0,
  feb: 1,
  mar: 2,
  apr: 3,
  may: 4,
  jun: 5,
  jul: 6,
  aug: 7,
  sep: 8,
  oct: 9,
  nov: 10,
  dec: 11,
}

function parseDatePart(datePart) {
  const s = datePart.trim()
  let d = new Date(s)
  if (!Number.isNaN(d.getTime())) return d

  const th = s.match(/^(\d{1,2})\s+(.+?)\s+(\d{4})$/)
  if (th) {
    const day = parseInt(th[1], 10)
    let year = parseInt(th[3], 10)
    if (year > 2400) year -= 543 // Convert BE to AD
    const mi = TH_MONTHS.indexOf(th[2])
    if (mi >= 0 && day >= 1 && day <= 31) {
      return new Date(year, mi, day)
    }
  }

  const en = s.match(/^(\d{1,2})\s+([A-Za-z]{3})\s+(\d{4})$/)
  if (en) {
    const day = parseInt(en[1], 10)
    let year = parseInt(en[3], 10)
    if (year > 2400) year -= 543 // Handle potentially stored BE
    const key = en[2].toLowerCase()
    const mi = EN_SHORT[key]
    if (mi != null && day >= 1 && day <= 31) {
      return new Date(year, mi, day)
    }
  }

  return null
}

/**
 * @param {string} raw
 * @param {'th'|'en'} localeLang
 * @returns {string}
 */
export function formatAvailableTimeDisplay(raw, localeLang) {
  if (raw == null || raw === '') return raw
  const trimmed = String(raw).trim()
  if (trimmed === '00:00 - 00:00') return trimmed

  const timeRangeRe = /^(.+?)(\d{1,2}:\d{2})\s*-\s*(\d{1,2}:\d{2})\s*$/
  const m = trimmed.match(timeRangeRe)
  if (!m) return raw

  let beforeFirstTime = m[1]
  const startT = m[2]
  const endT = m[3]

  const sepMatch = beforeFirstTime.match(/^(.*?)(\s+(?:เวลา|at)\s*)$/i)
  const datePart = (sepMatch ? sepMatch[1] : beforeFirstTime).trim()
  const sep = localeLang === 'en' ? ' at ' : ' เวลา '

  const parsed = parseDatePart(datePart)
  if (!parsed) return raw

  if (localeLang === 'th') {
    const dStr = parsed.toLocaleDateString('th-TH', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    })
    return `${dStr}${sep}${startT} - ${endT}`
  }

  const dStr = parsed.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  })
  return `${dStr}${sep}${startT} - ${endT}`
}
